import React from "react";
import { useLocation } from "react-router-dom";
import QPhototModuleSubtopic from "../../QPhotoModuleSubtopic";

const ALL_DSD_SUBTOPICS = [
    { name: 'Boolean Algebra: Basic definitions, Axiomatic definition of Boolean Algebra, Basic Theorems and Properties of Boolean Algebra', path: '/dsd-m1-s1' },
    { name: 'Boolean Functions, Canonical and Standard Forms', path: '/dsd-m1-s2' },
    { name: 'Simplification of Boolean functions. Gate-Level Minimization: The Map Method (K-map up to 4 variable), Product of Sums and Sum of Products Simplification', path: '/dsd-m1-s3' },
    { name: 'NAND and NOR Implementation', path: '/dsd-m1-s4' },
    { name: 'Logic Families: Digital Logic Gates, TTL and CMOS logic families', path: '/dsd-m1-s5' },
    { name: 'Verilog HDL', path: '/dsd-m2-s1' },
    { name: 'Design Procedure, Half Adder, Full Adder, Half Subtractor, Full Subtractor', path: '/dsd-m3-s1' },
    { name: 'Decoders, Encoders and applications', path: '/dsd-m3-s2' },
    { name: 'Multiplexers and De multiplexers', path: '/dsd-m3-s3' },
    { name: 'Parity generator and checker', path: '/dsd-m3-s4' },
    { name: 'Half Adder,Full Adder', path: '/dsd-mc-s1' },
    { name: 'N-bit Adder', path: '/dsd-mc-s2' },
    { name: '4-bit Adder and Subtractor', path: '/dsd-mc-s3' },
    { name: 'MUX,DEMUX', path: '/dsd-mc-s4' },
    { name: 'Decoder encoder', path: '/dsd-mc-s5' },
    { name: 'Priority Encoder', path: '/dsd-mc-s6' },
    { name: 'Array Multiplier and Booth multiplier', path: '/dsd-mc-s7' },
    { name: 'Flip Flops', path: '/dsd-mc-s8' },
    { name: 'Design of Counters', path: '/dsd-mc-s9' },
    { name: 'Finite State Machines (Mealy & Moore) and Sequence Detection', path: '/dsd-m6-s1' },
    { name: 'Programmable Logic Devices: PLA, PAL, CPLD, FPGA', path: '/dsd-m7-s1' }
];

const DSDModuleSubtopic = ({ title, videos, pdfLink, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_DSD_SUBTOPICS, subjectPath = '/subject-DSDModules' } = location.state || {};

    return (
        <QPhototModuleSubtopic
            title={title}
            videos={videos}
            pdfLink={pdfLink}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_DSD_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default DSDModuleSubtopic;
